import type { VaspWebhookEventsQuery } from '../types/vaspTypes'

// Query-keys factory for the VAISP operations module. Every read and every
// invalidation goes through this — never a raw array literal.
//
// The two branches are independent surfaces that happen to share a controller
// prefix: `holdings` is offering-scoped mirrored state, `webhookEvents` is the
// global inbound-event log. A re-mirror invalidates only its offering's
// holdings; a replay invalidates the whole event branch, which is why both
// replay mutations key off `webhookEventsAll()` rather than a single page.

export const vaspKeys = {
  all: ['vasp'] as const,

  holdingsAll: () => [...vaspKeys.all, 'holdings'] as const,
  /** Holdings mirrored for one offering. */
  holdings: (offeringId: string) => [...vaspKeys.holdingsAll(), offeringId] as const,

  webhookEventsAll: () => [...vaspKeys.all, 'webhook-events'] as const,
  /**
   * One filtered page of the event log. The whole filter object is in the key,
   * so changing a status or a page refetches rather than reusing the last page.
   */
  webhookEvents: (filters: VaspWebhookEventsQuery) =>
    [...vaspKeys.webhookEventsAll(), 'list', filters] as const,
}
